var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPocketLabsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "41px",
    viewBox: "0 0 30 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,18.4975939 C7,15.4603209 9.45722848,13 12.4954812,13 L31.3865281,13 C34.4203522,13 36.8820094,15.4650715 36.8820094,18.4975939 L36.8820094,32.1464081 C36.8820094,33.8286492 35.7235582,35.631987 34.1984783,36.3366789 L24.382901,40.8721515 C22.9852867,41.5179456 20.8931483,41.516294 19.4991084,40.8721515 L9.6835311,36.3366789 C8.15286172,35.6294043 7,33.8289535 7,32.1464081 L7,18.4975939 Z M10,18.4975939 L10,32.1464081 C10,32.6586149 10.4724346,33.396427 10.9418963,33.6133506 L20.7574736,38.1488232 C21.3539417,38.4244326 22.5260651,38.4253579 23.1245358,38.1488232 L32.9401131,33.6133506 C33.4055412,33.3982908 33.8820094,32.6565823 33.8820094,32.1464081 L33.8820094,18.4975939 C33.8820094,17.1209956 32.7625665,16 31.3865281,16 L12.4954812,16 C11.1149279,16 10,17.1163311 10,18.4975939 Z M26.4116799,4 C25.5832528,4 24.9116799,3.32842712 24.9116799,2.5 C24.9116799,1.67157288 25.5832528,1 26.4116799,1 C27.2401071,1 27.9116799,1.67157288 27.9116799,2.5 C27.9116799,3.32842712 27.2401071,4 26.4116799,4 Z M23.4116799,11 C22.0309681,11 20.9116799,9.88071187 20.9116799,8.5 C20.9116799,7.11928813 22.0309681,6 23.4116799,6 C24.7923918,6 25.9116799,7.11928813 25.9116799,8.5 C25.9116799,9.88071187 24.7923918,11 23.4116799,11 Z M26.9116799,27 C24.7025409,27 22.9116799,25.209139 22.9116799,23 C22.9116799,20.790861 24.7025409,19 26.9116799,19 C29.1208189,19 30.9116799,20.790861 30.9116799,23 C30.9116799,25.209139 29.1208189,27 26.9116799,27 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logos/PocketLabs/Icon",
    transform: "translate(-7.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#3A4054",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketLabsIcon);
export default __webpack_public_path__ + "static/media/PocketLabs-icon.8b0291ec5b78f845e09c41e16cf44d4e.svg";
export { ForwardRef as ReactComponent };